<template>
  <!-- 
  1.화면ID      : MCF_BT_002
  2.화면명      : 스케줄러 이력 조회
  3.작성자      : 김찬종 차장
  4.화면설명    : 스케줄러 실행이력을 조회한다.
  5.Descrition : 2024.04.02 최초작성
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->
  <div class="content-wrap">
    <div>
      <!-- 검색 영역 시작 -->
      <div class="search-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="스케줄러ID">
                <template #end>
                  <ElSelect v-model="state.searchParams.sch_id" :options="state.schList"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-2">
            <div class="mb-3">
              <ElLabel name="성공여부">
                <template #end>
                  <ElSelect v-model="state.searchParams.success_yn" :options="state.ynList"/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <ElLabel name="등록일"/>
              <div class="d-flex">
                <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.fr_date = r" v-model="state.searchParams.fr_date"/>
                <span class="tilde">~</span>               
                <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.to_date = r" v-model="state.searchParams.to_date"/> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 검색 영역 종료 -->
      <div class="search-detail-wrap"></div>
      <div class="text-end py-2">
        <ElButton type="search" @buttonClick="onSearch()">검색</ElButton>
      </div>
      <!-- 그리드 영역 시작 -->
      <div class="table-responsive table-list table-cf">
        <DataTable
            :value="state.gridRowData"
            v-model:selection="state.selectRow" selectionMode="single"
            paginator :rows="20" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
            scrollable scrollHeight="400px"
            stripedRows
            @rowSelect="onRowSelect">
          <Column field="row_no" header="NO" style="min-width:4rem"></Column>
          <Column field="sch_nm" header="스케줄러명" style="min-width:12rem"></Column>
          <Column field="begin_dt" header="시작일시" style="min-width:11rem; text-align:center"></Column>
          <Column field="end_dt" header="종료일시" style="min-width:11rem; text-align:center"></Column>
          <Column field="success_yn" header="성공여부" style="min-width:5rem; text-align:center"></Column>
          <Column field="message" header="메시지" style="max-width:15rem; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"></Column>
          <Column field="reg_dt" header="등록일" style="min-width:7rem; text-align:center"></Column>
        </DataTable>
      </div>
      <!-- 그리드 영역 종료 -->
      <div class="text-end py-2">

      </div>


<div class="modal fade" id="msgModal" tabindex="-1" aria-labelledby="msgModalLabel" aria-hidden="false">
<div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
<div class="modal-content">
<div class="modal-header">
  <h1 class="modal-title fs-6" id="msgModalLabel">메시지</h1>
  <ElButton type="modelHeaderClose"></ElButton>
</div>
<div class="modal-body">
  <div class="register-wrap">
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <ElTextarea v-model="msg.message" class="form-control" :rows="10" disabled/>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive table-list">
    <!--grid 영역-->
  </div>
</div>
<div class="modal-footer">
  <ElButton type="modelFooterClose"@buttonClick="closeModal()">닫기</ElButton>
</div>
</div>
</div>
</div>


    </div>
  </div>
  <ElInput v-show="false" data-bs-toggle="modal" data-bs-target="#msgModal" ref="msgModalRef"/>
</template>

<script setup>   
  import {reactive,ref,onBeforeMount,onMounted,computed} from 'vue';
  import DatePicker     from '@/components/common/DatePicker';
  import common         from '@/js/common';
  import DataTable      from 'primevue/datatable';
  import Column         from 'primevue/column';

  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { schdLogList } from '@/api/batch';
  const msg = ref({});
  const msgModalRef = ref();

  /** 검색기간 초기화 */
  const today = new Date();
  const frday = common.addMonth(today, -1);

  const frDate = common.dateFormat(frday);
  const toDate = common.dateFormat(today);

  onBeforeMount(() => {

  });

  onMounted(async () => {
    state.searchParams.sch_id = "All";
    state.searchParams.success_yn = "All";
    state.searchParams.fr_date = frDate;
    state.searchParams.to_date = toDate;
    await onSearch();
  });

  //변수 선언 영역 
  const state = reactive({
      gridRowData :[],
      searchParams : {
          sch_id     : '',
          success_yn : '',
          fr_date    : '',
          to_date    : '',
          page_count : 1,
          unit_count : 100000
      },
      schList : [
                  {text: '전체',                  value: 'All'},
                  {text: '영업기회 알람 스케줄러', value: 'SchedulerSalesOptyAlarm'},
                  {text: '영업기회 메일 스케줄러', value: 'SchedulerSalesOptyEmail'},
                  {text: '임시자료 삭제 스케줄러', value: 'SchedulerTmpDataRemove'},
                  {text: '프로시저 크론 스케줄러', value: 'SchedulerProcedureCron' }
                ],
      ynList : [
                  {text: '전체', value: 'All'},
                  {text: '성공', value: 'Y'},
                  {text: '실패', value: 'N'}
                ]
  });

  const onSearch = async () => {
    try {
      setIsLoading(true)
      const res = await schdLogList(state.searchParams)
      state.gridRowData = res.rtn;
    } catch (err) {
      alert("전송 중 에러가 발생하였습니다.");
    } finally {
      setIsLoading(false)
    }
  };

  const onRowSelect = (event) => {
      if(event.type == 'row') {
        msg.value = {...event.data};
        msgModalRef.value.input.click();
      }
    };

    const closeModal = () => {
      msgModalRef.value.input.click();
      msg.value = {};
    };
</script>
